import * as React from 'react';

function SupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 18.9H11a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1M11 17.4a2 2 0 1 0 0 4h1.5a2 2 0 1 0 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.75 8.546.02-.129a5.6 5.6 0 0 1 .796-2.008C8.254 5.35 9.528 4.25 12 4.25s3.746 1.1 4.434 2.159a5.6 5.6 0 0 1 .816 2.136V18.75H14a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 .75-.75v-3.25H21a.75.75 0 0 0 .75-.75V11a.75.75 0 0 0-.75-.75h-2.25V8.5l-.004-.075L18 8.5l.746-.075v-.01l-.003-.017a3 3 0 0 0-.037-.245 7.1 7.1 0 0 0-1.015-2.562C16.754 4.15 15.028 2.75 12 2.75s-4.754 1.4-5.691 2.841a7.1 7.1 0 0 0-1.045 2.751l-.007.056-.002.017v.006l-.001.003L6 8.5l-.746-.075-.004.075v1.75H3a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75zm-1.5 3.204h-1.5v3h1.5zm13.5 0v3h1.5v-3z"
  }));
}

export { SupportIcon };
